import taskManagerApi from '@/features/shared/services/taskManagerApi';
/**
 * Fetch statistics about tasks by status.
 */
export async function fetchTaskStats(filters) {
    try {
        const response = await taskManagerApi.get('/task/stats', {
            params: filters,
        });
        return response.data.data;
    }
    catch (error) {
        throw new Error("Impossible de r\xE9cup\xE9rer les statistiques des t\xE2ches");
    }
}
